<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'

import Datepicker from 'vuejs-datepicker'
import InventoryList from 'components/InventoryList'
import InventoryMap from 'components/InventoryMap'
import dateUtils from 'utils/dateUtils'
import domUtils from 'utils/domUtils'

export default {
  name: 'inventory-list-map-with-date-picker',
  props: {
    shouldLockDate: {
      type: Boolean,
    },
    hideTickets: {
      type: Boolean,
      default: false,
    },
    disableInlineCheckout: {
      type: Boolean,
      default: false,
    },
    disableGuestlist: {
      type: Boolean,
      default: false,
    },
    checkoutUrl: {
      type: String,
    },
    //THEMEING
    theme: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      datePickerDisabledOptions: {
        to: null,
        from: null,
      },
      sidebarHeight: 0,
      rightColumnOffsetTop: null,
    }
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      inventory: (state) => state.inventory.current,
      //
      eventId: (state) => state.config.eventId,
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    hasDate() {
      return this.date >= 0
    },
    utcDate() {
      return this.date ? dateUtils.toUTCDateWithoutTime(this.date) : ''
    },
  },
  methods: {
    onInventoryListUpdated() {
      this.$emit('updated')
    },
    onInventoryMapUpdated() {
      this.$emit('updated')
    },
    onDatepickerSelected(newDate) {
      this.loading = true

      const date = dateUtils.toUTCMomentWithoutTime(newDate)

      this.$store.dispatch('setCurrentDate', date)
    },
    onDatepickerOpened() {
      this.$emit('onDatepickerOpened')
    },
    onDatepickerClosed() {
      this.$emit('updated')
    },
    onIframeBlurred() {
      this.$refs.datePicker.close()

      this.$refs.inventoryMap.unhighlightAllTables()
      this.$refs.inventoryMap.hidePopper()
    },
    onWindowScrolled(options = {}) {
      const bodyHeight = domUtils.outerHeight(document.body)
      const rightColumnHeight = domUtils.outerHeight(this.$refs.rightColumnEl)

      const offset = (options.iframeOffset ? options.iframeOffset.top || 1 : 1) * -1

      if (rightColumnHeight + offset > bodyHeight) {
        return
      }

      window.requestAnimationFrame(() => {
        this.rightColumnOffsetTop = offset > 0 ? `${offset}px` : 0
      })
    },
    onInventoryMouseover(inventory) {
      this.$refs.inventoryMap.unhighlightAllTables()

      if (inventory.venueLayoutSection) {
        this.$refs.inventoryMap.highlightTablesByLayoutSectionId(inventory.venueLayoutSection)
      }
    },
    onInventoryMouseleave(inventory) {
      if (inventory.venueLayoutSection) {
        this.$refs.inventoryMap.unhighlightTablesByLayoutSectionId(inventory.venueLayoutSection)
      }
    },
    onInventorySelected(data) {
      if (!data) throw new Error('data is required')
      if (!data.inventory || data.inventory.quantityLeft < 1) return

      this.$refs.inventoryMap.hidePopper()

      const options = {
        venueId: this.venue.id,
        inventory: data.inventory,
        inventoryQuantity: data.inventoryQuantity,
        attributionId: this.attributionId,
        client: this.client,
      }

      this.$emit('scrollTop')

      this.$emit('inventorySelected', options)
    },
    onInventorySectionClicked(data) {
      if (!data) throw new Error('data is required')
      if (!data.layoutSection) return

      this.$emit('scrollTop')

      this.$refs.inventoryList.selectSection(data.layoutSection)
    },
    onWindowResize() {
      this.resizeSidebar()
    },
    onFloorplanLoaded() {
      this.resizeSidebar()

      this.$emit('updated')
    },
    resizeSidebar() {
      const floorPlanContainerEl = this.$el.querySelectorAll('.floorplan-container')[0]

      if (!floorPlanContainerEl) {
        return
      }

      const outerHeight = domUtils.outerHeight(floorPlanContainerEl)

      this.sidebarHeight = (outerHeight || 0) + 60 //add for the top bar
    },
  },
  components: {
    Datepicker,
    InventoryList,
    InventoryMap,
  },
  created() {
    const maxDate =
      this.venue && this.venue.inventoryTimeframe
        ? moment()
            .utc()
            .add(this.venue.inventoryTimeframe - 1, 'day')
        : null

    this.datePickerDisabledOptions.to = moment.utc().subtract(1, 'day').toDate()
    this.datePickerDisabledOptions.from = maxDate ? maxDate.toDate() : null
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize)
  },
  updated() {
    this.resizeSidebar()
    this.$emit('updated')
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/InventoryListMapWithDatePicker/index.vue